import { createTheme } from '@mui/material/styles';

const generalSettings = {
  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: 'h4' },
          style: {
            //fontFamily: "Exo2SemiBold",
            fontFamily: "Satoshi-Variable",
            color: '#323B98',
          },
        },
        {
          props: { variant: "body1" },
          style: {
            //fontFamily: "Exo2Regular"
            fontFamily: "Satoshi-Variable",
          }
        }
      ],
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          boxShadow: 'none',
          ...(ownerState.variant === 'contained' && {
            color: "#323B98",
            backgroundColor: "#00DB94",
            '&:hover': {
              boxShadow: 'none',
              color: "#fff",
              backgroundColor: "#707070"
            },
          }),
          ...(ownerState.variant === 'outlined' && {
            color: "#fff",
            backgroundColor: "#707070",
            '&:hover': {
              color: "#323B98",
              backgroundColor: "#00DB94",
              border: "1px solid #00DB94"
            },
          }),
        }),
      },
    },
  },
};

const CUSTOM_MUI_GENERAL_THEME = createTheme({}, generalSettings);

const CUSTOM_MUI_BUTTON_THEME = createTheme({
  typography: {
    fontFamily: [
      //'Exo2Medium',
      //'sans-serif',
      'Satoshi-Variable'
    ].join(','),
  },
}, generalSettings);

const CUSTOM_MUI_TEXT_FIELD_THEME = createTheme({
  typography: {
    fontFamily: [
      //'Exo2SemiBold',
      //'sans-serif',
      'Satoshi-Variable'
    ].join(','),
  },
}, generalSettings);

const HIDE_IN_PRINT_CLASS = "hide-in-print";
const STEPPER_STEPS = ['Datos Personales', 'Datos Tributarios', 'Datos Laborales', 'Datos Bancarios'];
const WEB = "https://winvest.ar"


//const CLIENT_REQUIREMENTS = "wbPd0";
const CLIENT_REQUIREMENTS = "wbPd1";

//const CLIENT = "pristine";
//const CLIENT_STORAGE = "wb-pristine";

const CLIENT = "winvest";
const CLIENT_STORAGE = "wb-winvest";

//const BACKEND = "http://34.151.226.43:9098/"; //TEST
//const BACKEND = "http://localhost:9098/"; //LOCAL
//const BACKEND = "http://34.95.194.101:9098/"; //PROD
const BACKEND = "https://api.winvest.ar/"; //PROD


//const STORAGE = "http://34.151.226.43:9096/api/files/upload";//TEST
//const STORAGE = "http://localhost:9096/api/files/upload";//LOCAL
//const STORAGE = "http://34.95.194.101:9096/api/files/upload";//PROD PRISTINE
//const STORAGE = "http://34.95.194.101:9097/api/files/upload";//PROD WINVEST
//const STORAGE = "https://storagepristine.winvest.ar/api/files/upload";//PROD PRISTINE
const STORAGE = "https://storagewinvest.winvest.ar/api/files/upload";//PROD WINVEST

//const FIXOR = "http://localhost:9000/"; //LOCAL
//const FIXOR = "http://35.215.231.109:9000/"; //TEST
const FIXOR = "https://fixor.winvest.ar/";//PROD

//const FIXMD = "http://localhost:9099/"; //LOCAL
//const FIXMD = "http://34.95.194.101:9099/";//PROD
const FIXMD = "https://fixmd.winvest.ar/";//PROD

//const FIXCON = "http://localhost:9001/"; //LOCAL
//const FIXCON = "http://35.215.231.109:9001/"; //TEST
const FIXCON = "https://fixcon.winvest.ar";//PROD

//const FIXMDSOCKET = "ws://34.95.194.101:9099/prices";//PROD
const FIXMDSOCKET = "wss://fixmd.winvest.ar/prices";//PROD

const constants = {
  CUSTOM_MUI_GENERAL_THEME,
  CUSTOM_MUI_BUTTON_THEME,
  CUSTOM_MUI_TEXT_FIELD_THEME,
  HIDE_IN_PRINT_CLASS,
  STEPPER_STEPS,
  CLIENT,
  WEB,
  BACKEND,
  STORAGE,
  FIXOR,
  CLIENT_STORAGE,
  FIXMD,
  FIXMDSOCKET,
  FIXCON,
  CLIENT_REQUIREMENTS
};

export default constants;

